module.exports = __webpack_public_path__ + "static/img/banner-top-1.b137722.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner-top-1.png
// module id = 0kvd
// module chunks = 0